import { APIClient } from 'cx-api-client-lite';

const Content = new APIClient({
  getBrowse: {
    path: '/content/v1/browse',
    method: 'GET',
  },
  fetchWatchlistItems: {
    path: '/content/v1/watchlist/{accountId}/{contentIds}',
    method: 'GET',
  },
  addToWatchlist: {
    path: `/content/v1/watchlist/{accountId}`,
    method: 'POST',
  },
  removeFromWatchlist: {
    path: `/content/v1/watchlist/{accountId}/{seriesId}`,
    method: 'DELETE',
  },
});

export default Content;
